export enum BoardStatusOption {
  ACTIVE = '9fd9ffb0-d27f-11eb-b8bc-0242ac130003',
  PASSIVE = '9fda0492-d27f-11eb-b8bc-0242ac130003',
}
